export const APP_ROUTER = {
    INDEX: '/',
    HOME: '/home',
    COMPONENT: '/component',
    USER: '/user',
    ORDER: '/order',
    PRODUCT: '/product',
    PRODUCTDETAIL: '/product/:id',
    ADD_PRODUCT: '/product/add-product',
    COLLECTION: '/collection',
    SALE: '/sale',
    SEARCH: '/search/:searchValue',
    SEARCHPAGE: '/search',
    PURCHASE: '/purchase',
    CART: '/cart',
    CARTTEST: 'carttest',
    LISTCART: '/shopping-cart',
    AUTH: 'auth',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REGISTER: '/auth/register',
    CHANGE_PASSWORD: 'change-password',
    REFRESH_TOKEN: '/auth/accessToken-generate',
    ERRORS: '/error',
}
export const color = {
    blue: '#2F5ACF',
    gray: '#D9D9D9',
}
export const port = 8080
